import { FormConfigContext } from '@juvare/common-form-ui/FormConfigContext';
import { valueProviderCache } from '@juvare/common-form-ui/valueProviderCache';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { getDataValue } from '@juvare/json-data-util';
import React from 'react';
export function useValues({ values, valueProviderType, valueProvider, valueProvidersFromProps, filterData, }) {
    const formConfigContext = React.useContext(FormConfigContext);
    const valueProviders = valueProvidersFromProps !== null && valueProvidersFromProps !== void 0 ? valueProvidersFromProps : formConfigContext.valueProviders;
    const [items, setItems] = React.useState();
    const [isLoading, setIsLoading] = React.useState(true);
    React.useEffect(() => {
        if ((valueProvider === null || valueProvider === void 0 ? void 0 : valueProvider.type) || valueProviderType) {
            const valueProviderTypeToMatchAgainst = (valueProvider === null || valueProvider === void 0 ? void 0 : valueProvider.type) || valueProviderType;
            const matchedValueProvider = valueProviders === null || valueProviders === void 0 ? void 0 : valueProviders.find((vp) => vp.type === valueProviderTypeToMatchAgainst);
            let params = valueProvider === null || valueProvider === void 0 ? void 0 : valueProvider.params;
            if ((valueProvider === null || valueProvider === void 0 ? void 0 : valueProvider.paramsFromFormData) && filterData) {
                params = getDataValue(filterData, valueProvider === null || valueProvider === void 0 ? void 0 : valueProvider.paramsFromFormData);
            }
            if (matchedValueProvider) {
                setIsLoading(true);
                setItems(undefined);
                valueProviderCache
                    .getValue(matchedValueProvider, params)
                    .then(setItems)
                    .catch((error) => {
                    handleErrorSnackbar(error);
                    setItems([]);
                })
                    .finally(() => setIsLoading(false));
            }
            else {
                console.error('Value provider not found, type: ' + valueProviderTypeToMatchAgainst);
            }
        }
    }, [valueProviderType, valueProvider, valueProviders, filterData]);
    if (values) {
        return [values, false];
    }
    else {
        return [items !== null && items !== void 0 ? items : emptyArray, isLoading];
    }
}
const emptyArray = [];
